import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'largeNumberFormat' })
export class LargeNumberPipe implements PipeTransform {
  transform(value: number | string): string {
    let numberToFormat = value.toString(); // Treat the value as a string to avoid rounding issues

    // Split the number into integer and decimal parts (if any)
    let [integerPart, decimalPart] = numberToFormat.split('.');

    // Apply comma formatting to the integer part
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // If there's a decimal part, limit it to 2 decimal places; otherwise, ensure 2 decimal places
    if (decimalPart) {
      decimalPart = decimalPart.slice(0, 2); // Take only the first 2 decimal places
    } else {
      decimalPart = '00'; // Default to '.00' if there's no decimal part
    }

    // Return the formatted number with commas and 2 decimal places
    return `${integerPart}.${decimalPart}`;
  }
}
